module.exports = __webpack_public_path__ + "assets/centos.e8ab91e4.svg";